import { Component } from '@angular/core';

@Component({
  selector: 'app-ban-user-modal',
  templateUrl: './ban-user-modal.component.html',
  styleUrls: ['./ban-user-modal.component.css'],
})
export class BanUserModalComponent {
  constructor() {}
}
